// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"7b95c778","542":"4677084b","834":"e17f69e8"}[chunkId] + ".chunk.js";
};